import $ from "jquery";

const __popupData = ({
  data,
  dataPdf,
  taxonomy,
  selectorStore,
  customize = null,
  price = null,
  isUnselect = false,
}) => {
  let popupPdf__dataItem__changed = dataPdf;
  if (!price) {
    const specificaties        = dataPdf.specificaties;
    let   specificaties_filter = specificaties;
    const parentKey            = taxonomy.split("-")[0];
    const attributeKey         = taxonomy.split("-")[1];

    specificaties_filter = specificaties.map((spec) => {
      let newSpec = spec;
      if ( spec.name.replaceAll(" ", "_").toLowerCase() === parentKey.toLowerCase()) {
        const attributeIndex = newSpec["attributes"].findIndex( (a) => a.key.replaceAll(" ", "_").toLowerCase() === attributeKey);
          
          if (attributeIndex > -1) {
            if (isUnselect) {
              spec["attributes"].splice(attributeIndex, 1);
            } else {
              spec["attributes"][attributeIndex]["value"] = data.title;
              spec["attributes"][attributeIndex]["price"] = data.price;
              

            if (customize != null) {
              spec["attributes"][attributeIndex]["customize"] = !customize ? null : { ...spec["attributes"][attributeIndex]["customize"], ...customize,};
            }
          }
        } else {
          const attributeKeyRender = attributeKey.replaceAll("_", " ");
          spec["attributes"].push({
              key: attributeKeyRender.charAt(0).toUpperCase() + attributeKeyRender.slice(1),
              value: data.title,
              customize: customize,
              price: data.price,
          });
        }
      }

      return newSpec;
    });

    popupPdf__dataItem__changed["specificaties"] = specificaties_filter;
  }

  if (price) {
    popupPdf__dataItem__changed["price"] = price;
  }

  if (
    typeof $(selectorStore).attr("data-item") !== "undefined" &&
    $(selectorStore).attr("data-item") !== false
  ) {
    $(selectorStore).attr(
      "data-item",
      JSON.stringify(popupPdf__dataItem__changed)
    );
  }

  if ($(`${selectorStore}__input`).length > 0) {
    $(`${selectorStore}__input`).val(
      JSON.stringify(popupPdf__dataItem__changed)
    );
  }

  return popupPdf__dataItem__changed;
};

export default __popupData;
